module.exports = __webpack_public_path__ + "static/media/um.3d347682.svg";